import { Sparkle } from "@phosphor-icons/react";

export default function AIButton({ onClick, loading, testid, label = "AI Polish" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className="btn-ai text-[10px] px-2.5 py-1.5"
      data-testid={testid}
    >
      <Sparkle size={12} weight="fill" />
      {loading ? "Polishing…" : label}
    </button>
  );
}
